import React, { useEffect, useRef, useState } from "react";
import { apiPost } from "../apiClient";
import { clearPendingPlan } from "../utils/pendingPlan";

// Terminal landing spot for the "Start with Pro" journey: the account now exists and is signed
// in, so the only thing left is to hand the browser to Stripe.
const CheckoutRedirectPage = ({ token, onCancelled }) => {
  const started = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (started.current || !token) return;
    started.current = true;

    const startCheckout = async () => {
      // Clear before redirecting. If Stripe or the network fails the user must land in the app
      // normally rather than being bounced at checkout on every subsequent login.
      clearPendingPlan();
      try {
        const data = await apiPost("/billing/checkout-session", undefined, { token });
        window.location.href = data.url;
      } catch (apiError) {
        setError(apiError.message || "Checkout could not be started.");
      }
    };

    startCheckout();
  }, [token]);

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        {error ? (
          <>
            <h1 style={{ margin: "0 0 12px", fontSize: "22px" }}>Checkout unavailable</h1>
            <p style={{ color: "#94a3b8", lineHeight: 1.5, margin: "0 0 24px" }}>{error}</p>
            <button style={buttonStyle} onClick={onCancelled}>
              Continue to Taskit
            </button>
          </>
        ) : (
          <>
            <h1 style={{ margin: "0 0 12px", fontSize: "22px" }}>Taking you to secure checkout…</h1>
            <p style={{ color: "#94a3b8", lineHeight: 1.5, margin: 0 }}>
              Payment is handled by Stripe. You will come back here once it is complete.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

const pageStyle = {
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#030712",
  fontFamily: "Arial",
  color: "white"
};

const cardStyle = {
  width: "420px",
  padding: "36px",
  borderRadius: "18px",
  textAlign: "center",
  background: "rgba(15,23,42,0.95)",
  border: "1px solid rgba(255,255,255,0.08)"
};

const buttonStyle = {
  width: "100%",
  padding: "14px",
  borderRadius: "12px",
  border: "none",
  cursor: "pointer",
  background: "#4f46e5",
  color: "white",
  fontWeight: 700
};

export default CheckoutRedirectPage;
